<div class="bulletin-overlay" *ngIf="visible" [class.urgent]="isUrgent" [class.critical]="isCritical">
  <div class="bulletin-backdrop" (click)="dismiss()"></div>
  <div class="bulletin-container">
    <div class="bulletin-card">
      <!-- Header -->
      <div class="bulletin-header">
        <div class="bulletin-icon-wrapper" [class.pulse]="isUrgent">
          <span class="bulletin-icon">⚠️</span>
        </div>
        <div class="bulletin-title-group">
          <h2 class="bulletin-title">System Maintenance Notice</h2>
          <p class="bulletin-subtitle">Please save your work</p>
        </div>
        <button class="bulletin-close" (click)="dismiss()" title="Dismiss (you can still save your work)">
          ✕
        </button>
      </div>

      <!-- Progress Bar -->
      <div class="bulletin-progress-track">
        <div class="bulletin-progress-bar"
          [style.width.%]="progressPercent"
          [class.bar-urgent]="isUrgent"
          [class.bar-critical]="isCritical">
        </div>
      </div>

      <!-- Message -->
      <div class="bulletin-body">
        <p class="bulletin-message">{{ message }}</p>
      </div>

      <!-- Countdown -->
      <div class="bulletin-countdown" [class.countdown-urgent]="isUrgent" [class.countdown-critical]="isCritical">
        <div class="countdown-label" *ngIf="!isCritical">Time remaining</div>
        <div class="countdown-label" *ngIf="isCritical">Deployment in progress</div>
        <div class="countdown-timer" *ngIf="!isCritical">
          <span class="countdown-digit">{{ minutes }}</span>
          <span class="countdown-sep">:</span>
          <span class="countdown-digit">{{ seconds }}</span>
        </div>
        <div class="countdown-timer" *ngIf="isCritical">
          <span class="countdown-digit">00</span>
          <span class="countdown-sep">:</span>
          <span class="countdown-digit">00</span>
        </div>
      </div>

      <!-- Footer -->
      <div class="bulletin-footer">
        <span class="bulletin-sent-by">Sent by {{ sentBy }}</span>
        <button class="bulletin-dismiss-btn" (click)="dismiss()">
          Acknowledge &amp; Dismiss
        </button>
      </div>
    </div>
  </div>
</div>
